import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { NewStreetNamingRequestComponent } from './new-street-naming-request/new-street-naming-request.component';
import { SNNewRequestFormService } from './services/new-request-form/new-request-form.service';
import { StreetNamingPortalRoutingModule } from './street-naming-portal-routing.model';
import { StreetNamingPortalComponent } from './street-naming-portal.component';

@NgModule({
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    StreetNamingPortalRoutingModule,
  ],
  declarations: [StreetNamingPortalComponent, NewStreetNamingRequestComponent],
  providers: [SNNewRequestFormService, SNNewRequestFormService],
})
export class StreetNamingPortalModule {}
